import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline'
import WorkOutlineIcon from '@mui/icons-material/WorkOutline'
import { Box, Typography } from '@mui/material'

type QuotesTitleProps = {
  title?: string
  example?: string
  image?: string
  seats?: number
  luggage?: number
}

const QuotesTitle = ({
  title,
  example,
  image,
  seats,
  luggage,
}: QuotesTitleProps) => (
  <Box
    component="div"
    sx={{
      width: '100%',
      backgroundColor: '#F7F7F7',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      maxHeight: '65px',
      overflow: 'hidden',
      padding: '0 15px',
    }}
  >
    <Box
      component="div"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        textAlign: 'center',
        padding: '0',
      }}
    >
      {title && (
        <Typography
          component="p"
          sx={(theme) => ({
            color: theme.palette.brand.light,
            fontWeight: 'bold',
            padding: '20px 0px',
            minWidth: '100px',
            marginRight: '7.5px',
          })}
        >
          {title}
        </Typography>
      )}
      <Box
        component="hr"
        sx={{
          borderLeft: '1px solid',
          borderColor: '#D9DCDF',
          height: '100px',
          padding: 0,
          margin: 0,
        }}
      />
      {example && (
        <Box
          component="p"
          sx={{
            color: '#888888',
            fontSize: '12px',
            padding: 0,
            margin: 0,
            marginLeft: '10px',
          }}
        >
          For example {example}
        </Box>
      )}
    </Box>

    <Box
      component="div"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '10px',
        padding: '20px 20px',
      }}
    >
      {seats && (
        <Box
          component="div"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            fontWeight: 'normal',
            alignItems: 'center',
            gap: '5px',
            alignSelf: 'flex-end',
          }}
        >
          <PeopleOutlineIcon />
          <span>{seats}</span>
        </Box>
      )}

      {luggage && (
        <Box
          component="div"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            fontWeight: 'normal',
            alignItems: 'center',
            gap: '5px',
            alignSelf: 'flex-end',
          }}
        >
          <WorkOutlineIcon />
          <span>{luggage}</span>
        </Box>
      )}
      {image && (
        <Box
          component="img"
          src={image}
          style={{
            maxHeight: '30px',
            width: 'auto',
            margin: '0 0 0 10px',
          }}
        />
      )}
    </Box>
  </Box>
)

export default QuotesTitle
